// extracted by mini-css-extract-plugin
export default {"imgFlag":"Flag_imgFlag__DHoK0","main":"Flag_main__4JmvF","wrapper":"Flag_wrapper__pDPyR"};